export const hu = {
  // Header
  'header.brand': 'Napi 11-es',
  'header.shotProgress': '{n}/{total}',
  'header.openSettings': 'Beállítások',
  'header.mute':           'Hang elnémítása',
  'header.unmute':         'Hang bekapcsolása',

  // Menu (Phaser canvas)
  'menu.play': 'Rúgj!',

  // Shot outcome flash (Phaser canvas)
  'outcome.goal':  'GÓL!',
  'outcome.saved': 'VÉDÉS!',
  'outcome.miss':  'MELLÉ!',

  // Share
  'share.title': 'Megosztás',
  'share.shareButton': 'Megoszt',
  'share.copyButton': 'Másol',
  'share.copySuccess': 'Vágólapra másolva',
  'share.copyError': 'Másolás sikertelen',
  'share.copyUnavailable': 'A vágólap nem érhető el',
  'share.shareError': 'Megosztás sikertelen',
  'share.streakLabel': 'napos sorozat',

  // Stats
  'stats.title': 'Mai statisztika',
  'stats.loading': 'Betöltés...',
  'stats.empty': 'Még nincs elég adat a mai napra',
  'stats.error': 'A statisztika nem érhető el',
  'stats.retry': 'Újra',
  'stats.todayAverage': 'Mai átlag',
  'stats.scoredAtLeast3': 'Legalább 3-at lőtt',
  'stats.shotLeftFirst': 'Először balra lőtt',
  'stats.zoneHitRate': '{zone} találati arány',

  // Settings
  'settings.title': 'Beállítások',
  'settings.sound': 'Hang',
  'settings.reducedMotion': 'Csökkentett mozgás',
  'settings.hardMode': '🕶️ Nehéz mód',
  'settings.hardModeHelp': 'Elrejti a mai kapus kártyáját a meccs előtt. Ugyanaz a pálya, ugyanaz a pont.',
  'settings.assist': '💡 Segítség',
  'settings.assistHelp': 'Az 5. lövés után megmutat egy alacsony esélyű zónát. Ezzel lemondasz a 🕶️ jelölésről.',
  'settings.locale': 'Nyelv',
  'settings.localeComingSoon': 'Hamarosan',
  'settings.resetProgress': 'Haladás törlése',
  'settings.resetConfirmTitle': 'Biztosan törlöd?',
  'settings.resetConfirmBody': 'Minden helyi haladásod elvész.',
  'settings.cancel': 'Mégse',
  'settings.confirm': 'Megerősít',
  'settings.versionFooter': 'v{version} · napi11es.com',

  // Countdown
  'countdown.nextPuzzle': 'Újra rúghatsz: {hours}h {minutes}m',
  'countdown.newPuzzleAvailable': 'Új meccs vár',
  'countdown.reload': 'Frissítés',

  // Badges
  'badge.hawkEye':   'Sólyom-szem',
  'badge.hatTrick':  'Mesterhármas',
  'badge.perfect':   'Tökéletes',
  'badge.ironDoor':  'Vasajtó',
  'badge.brilliant': 'Briliáns',

  // Result
  'result.communityLine': 'Te: {self} · Közösség: {avg}',
  'result.scoreLabel': 'Eredmény',
  'result.streakDays': 'nap',
  'result.day1Welcome': 'Első napod!',
  'result.day2Welcome': 'Második napod!',

  // Archetype — keeper of the day
  'archetype.todaysKeeper': 'Mai kapus',
  'archetype.position': 'Kapus',
  'archetype.heatmapTitle': 'Hová ugrik',
  'archetype.heatmapHint': 'minél erősebb a szín, annál biztosabban véd ott',
  'archetype.season': 'Sezon 2026',
  'archetype.cardSerial': 'No. {n}',
  'archetype.difficulty.1': 'Könnyű',
  'archetype.difficulty.2': 'Közepes',
  'archetype.difficulty.3': 'Nehéz',
  'archetype.DIVER.name': 'Vetődő',
  'archetype.DIVER.hint': 'Sarkokra hajlik',
  'archetype.DIVER.persona': 'Lukács Dénes',
  'archetype.HIGH_WALL.name': 'Magas fal',
  'archetype.HIGH_WALL.hint': 'Felső sort védi',
  'archetype.HIGH_WALL.persona': 'Bognár Tamás',
  'archetype.LEFT_LEANER.name': 'Bal oldali',
  'archetype.LEFT_LEANER.hint': 'Saját bal felé hajlik',
  'archetype.LEFT_LEANER.persona': 'Erdei Levente',
  'archetype.CENTER_SPREAD.name': 'Középről szórt',
  'archetype.CENTER_SPREAD.hint': 'Közepről széles',
  'archetype.CENTER_SPREAD.persona': 'Pápai Bence',
  'archetype.WIDE_OPEN.name': 'Tárt kapu',
  'archetype.WIDE_OPEN.hint': 'Bárhova lőhetsz',
  'archetype.WIDE_OPEN.persona': 'Szigeti Márk',
  'archetype.TWO_CLUSTER.name': 'Két sarok',
  'archetype.TWO_CLUSTER.hint': 'Két helyet véd',
  'archetype.TWO_CLUSTER.persona': 'Csányi Norbert',
  'archetype.DIVER.truthTakeaway':         'A két felső sarokba vetődik — oldalra szinte mindig.',
  'archetype.HIGH_WALL.truthTakeaway':     'A felső sort védi — fent nehéz betalálni.',
  'archetype.LEFT_LEANER.truthTakeaway':   'A saját bal oldalát védi — oda húz.',
  'archetype.CENTER_SPREAD.truthTakeaway': 'Középen marad — fent és lent is középre vetődik.',
  'archetype.WIDE_OPEN.truthTakeaway':     'Nincs kedvenc zónája — bárhová vetődhet.',
  'archetype.TWO_CLUSTER.truthTakeaway':   'Két átlós sarkot véd — bal alsó és jobb felső.',

  // Archetype callout — multi-mode (Plan #5 §4.5)
  'archetype.heatmapHintPreplay': 'Még nem mutatkozott meg',
  'archetype.heatmapHintLive':    'Hányszor láttad ide ugrani?',
  'archetype.cellObservedCount':  '{count}×',
  'archetype.cellHiddenA11y':     '{position}, még nem láttad ide menni a kapust',
  'archetype.cellSeenA11y':       '{position}, {count}× láttad ide menni',
  'archetype.cellTruthA11y':      '{position}, {pct}%',
  'archetype.truthLabelTop':      'A kapus védelmi térképe',
  'archetype.position.LA': 'Bal felső sarok',
  'archetype.position.CA': 'Középső felső',
  'archetype.position.RA': 'Jobb felső sarok',
  'archetype.position.LF': 'Bal alsó sarok',
  'archetype.position.CF': 'Középső alsó',
  'archetype.position.RF': 'Jobb alsó sarok',
  // Assist (Plan #1 §4.3)
  'assist.revealZone': 'Mutass egy esélyt',
  'assist.hintCaption': 'Legkisebb esély most: {position}',

  // Errors
  'error.generic': 'Hiba történt',
  'reset.failed': 'Törlés sikertelen',
  'storage.unavailable': 'A helyi tárhely nem érhető el — adataid csak munkamenet erejéig maradnak meg',

  // Personal Statisztika (Plan #6 §6)
  'personalStats.title':             'Statisztika',
  'personalStats.titleWithUnseen':   'Statisztika – új jelvény',
  'personalStats.daysPlayed':        'Játszott napok',
  'personalStats.currentStreak':     'Jelenlegi sorozat',
  'personalStats.longestStreak':     'Leghosszabb sorozat',
  'personalStats.distribution':      'Eloszlás',
  'personalStats.engagementBadges':  'Sorozat-jelvények',
  'personalStats.performanceBadges': 'Teljesítmény-jelvények',
  'personalStats.empty':             'Játssz ma, kezdd el gyűjteni a jelvényeidet!',
  'personalStats.locked':            'Még hiányzik',
  'personalStats.newBadgeAnnounce':  'Új jelvény: {name}',

  'engagementBadge.firstKick': 'Első rúgás',
  'engagementBadge.rookie':    'Újonc',
  'engagementBadge.regular':   'Rendszeres',
  'engagementBadge.weekly':    'Hetes',
  'engagementBadge.biweekly':  'Két hetes',
  'engagementBadge.monthly':   'Havi',

  // Practice (Plan #9 §4.2)
  'practice.again': 'Gyakorlás',
  'practice.bannerActive': 'Gyakorló kör — nem számít bele',
  'practice.backToResult': 'Vissza az eredményhez',
} as const;
